import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function FileViewer() {
	const location = useLocation();
	const url = location.state?.url;

	return (
		<>
			{/* biome-ignore lint/a11y/useIframeTitle: <explanation> */}
			<iframe
				id="pdfIframe"
				src={url}
				className="w-screen h-screen overflow-auto"
			/>
		</>
	);
}
